// How the equipment list can be sorted: the toolbar's Sort select.
export const EQUIPMENT_SORTS = [
  { value: 'name', label: 'Name' },
  { value: 'roi', label: 'ROI' },
  { value: 'income', label: 'Income' },
  { value: 'days', label: 'Rental days' },
];
